import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AccountService } from 'app/core';
import { Task } from '../../shared/modules/legacy-tasks/tasks.types';
import { AggregatedTasksService } from 'app/modules/aggregated-tasks/aggregated-tasks.service';
import { LegacyTasksTabService } from '@shared/modules/legacy-tasks/services/tasks.service';
import { AccountFoldersService } from '../folders/folders.service';
import { Store } from '@ngxs/store';
import { AccountState } from 'app/state/account/state';
import { TaskActions } from '@tasks/state/actions';

@Injectable({
  providedIn: 'root',
})
export class TaskResolver {
  constructor(
    private _router: Router,
    private _aggregatedTasksService: AggregatedTasksService,
    private taskService: LegacyTasksTabService,
    private _accountService: AccountService,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._aggregatedTasksService.accountId = accountData.id;
      this.taskService.accountId = accountData.id; // This is necessary for the approval flow
      this.taskService.isGlobalTasks = true;
    });
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Task> {
    return this._aggregatedTasksService
      .getTaskById(+route.paramMap.get('task_list_id'), +route.paramMap.get('task_id'))
      .pipe(
        // Error here means the requested task is not available
        catchError((error) => {
          // Log the error
          console.error(error);

          // Get the parent url
          const parentUrl = state.url.split('/').slice(0, -1).join('/');

          // Navigate to there
          this._router.navigateByUrl(parentUrl);

          // Throw an error
          return throwError(() => new Error(error));
        }),
      );
  }
}

@Injectable({ providedIn: 'root' })
export class TaskFolderResolver {
  constructor(
    private readonly accountFoldersService: AccountFoldersService,
    private readonly store: Store,
  ) {
    this.accountFoldersService.accountId = this.store.selectSnapshot(AccountState.getAccount).id;
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Task> {
    return this.accountFoldersService.getFolder().pipe(map((folder) => folder));
  }
}
